import React, {FC} from 'react';
import {StyledLoading} from './Loading.styles';

export const Loading: FC = (props) => {
    return <StyledLoading {...props} />;
};
